var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandRow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11 -57)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11 57)",
    fill: "#fff",
    stroke: "#a4b9dd",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19 62)",
    fill: "#a4b9dd",
    stroke: "#a4b9dd",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 9,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 0.7,
    height: 7.7,
    rx: 0.35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.5 65.5) rotate(90)",
    fill: "#a4b9dd",
    stroke: "#a4b9dd",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 9,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 0.7,
    height: 7.7,
    rx: 0.35,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandRow);
export default __webpack_public_path__ + "static/media/ExpandRow.1f2b96c0cfa13f59f34aa944aef3bee4.svg";
export { ForwardRef as ReactComponent };